import BaseInputField from './BaseInputField';

class InputField extends BaseInputField {
	getValue() {
		const input = this._$input.get(0);
		const cleave = input ? input.customObjectCleave : null;

		if (cleave) {
			return cleave.getRawValue();
		}

		return super.getValue();
	}
}

export default InputField;
